import React from "react";

import talentLenzFinalConversionCtaBrochureCover from "../../images/talentlenz-final-conversion-cta-brochure-cover.png";
import talentLenzFinalConversionCtaBrochureDownloadIcon from "../../images/talentlenz-final-conversion-cta-brochure-download-icon.png";
import talentLenzFinalConversionCtaDemonstrationArrowIcon from "../../images/talentlenz-final-conversion-cta-demonstration-arrow-icon.png";
import talentLenzFinalConversionCtaLuminousBackground from "../../images/talentlenz-final-conversion-cta-luminous-background.png";

import "./TalentLenzFinalConversionCTA.css";

export default function TalentLenzFinalConversionCTA({
  demonstrationHref = "#contact",
  onBrochureClick,
}) {
  return (
    <section
      id="talentlenz-final-conversion-cta"
      className="talentlenz-final-conversion-cta"
      aria-labelledby="talentlenz-final-conversion-cta-title"
    >
      <img
        className="talentlenz-final-conversion-cta__background"
        src={talentLenzFinalConversionCtaLuminousBackground}
        alt=""
        aria-hidden="true"
        decoding="async"
      />

      <div className="talentlenz-final-conversion-cta__panel">
        <div className="talentlenz-final-conversion-cta__copy">
          <p className="talentlenz-final-conversion-cta__eyebrow">
            See TalentLenz in action
          </p>

          <h2
            id="talentlenz-final-conversion-cta-title"
            className="talentlenz-final-conversion-cta__title"
          >
            Make your next
            <br />
            shortlist
            <br />
            evidence-ready.
          </h2>
        </div>

        <p className="talentlenz-final-conversion-cta__description">
          <span className="talentlenz-final-conversion-cta__description-layout talentlenz-final-conversion-cta__description-layout--desktop">
            See how TalentLenz can turn your next high-volume
            <br />
            opportunity into a structured, explainable shortlist.
          </span>

          <span className="talentlenz-final-conversion-cta__description-layout talentlenz-final-conversion-cta__description-layout--landscape">
            Turn your next high-volume opportunity into
            <br />a structured, explainable shortlist.
          </span>

          <span className="talentlenz-final-conversion-cta__description-layout talentlenz-final-conversion-cta__description-layout--portrait">
            Turn your next high-volume opportunity into a structured,
            <br />
            explainable shortlist.
          </span>

          <span className="talentlenz-final-conversion-cta__description-layout talentlenz-final-conversion-cta__description-layout--mobile">
            Turn your next high-volume opportunity
            <br />
            into a structured, explainable shortlist.
          </span>
        </p>

        <img
          className="talentlenz-final-conversion-cta__brochure"
          src={talentLenzFinalConversionCtaBrochureCover}
          alt="TalentLenz product brochure titled From application overload to an evidence-ready shortlist."
          loading="lazy"
          decoding="async"
        />

        <div className="talentlenz-final-conversion-cta__actions">
          <a
            className="talentlenz-final-conversion-cta__button talentlenz-final-conversion-cta__button--primary"
            href={demonstrationHref}
          >
            <span className="talentlenz-final-conversion-cta__button-label">
              Book a demonstration
            </span>

            <img
              className="talentlenz-final-conversion-cta__button-icon talentlenz-final-conversion-cta__button-icon--arrow"
              src={talentLenzFinalConversionCtaDemonstrationArrowIcon}
              alt=""
              aria-hidden="true"
            />
          </a>

          <button
            type="button"
            className="talentlenz-final-conversion-cta__button talentlenz-final-conversion-cta__button--secondary"
            onClick={onBrochureClick}
            aria-label="Download the TalentLenz product brochure"
          >
            <img
              className="talentlenz-final-conversion-cta__button-icon talentlenz-final-conversion-cta__button-icon--download"
              src={talentLenzFinalConversionCtaBrochureDownloadIcon}
              alt=""
              aria-hidden="true"
            />

            <span className="talentlenz-final-conversion-cta__download-label talentlenz-final-conversion-cta__download-label--desktop">
              Download brochure
            </span>

            <span className="talentlenz-final-conversion-cta__download-label talentlenz-final-conversion-cta__download-label--compact">
              Download the brochure
            </span>
          </button>
        </div>

        <p className="talentlenz-final-conversion-cta__footer-label">
          <span className="talentlenz-final-conversion-cta__footer-layout talentlenz-final-conversion-cta__footer-layout--desktop">
            TalentLenz · Opportunity intelligence by AndUs
          </span>

          <span className="talentlenz-final-conversion-cta__footer-layout talentlenz-final-conversion-cta__footer-layout--compact">
            Opportunity intelligence by AndUs
          </span>
        </p>
      </div>
    </section>
  );
}
